import { useFetchPost } from "hooks/fetch/useFetchPost";
import { useMemo } from "react";

export function usePostEvent(onCompleted = undefined, onError = undefined) {
  const url = useMemo(() => `events/`, []);

  const { loading, error, data, postCallback } = useFetchPost(
    url,
    onCompleted,
    onError
  );

  return { loading, error, data, postEventCallback: postCallback };
}
